import "luxedo-canvas" // DONT DELETE
import type { Calibration } from "luxedo-data"
import { closeOverlay, openConfirmOverlay, openOverlay } from "overlay"
import { MaskEditor } from "@calibration/masking"
import { Toast } from "toaster"

export function openMaskEditorOverlay(calibration: Calibration) {
	const overlayId = openOverlay(MaskEditor, {
		classHeading: "no-underline",
		classOverlay: "no-pad",
		beforeClose: () =>
			new Promise<void>((res, rej) => {
				openConfirmOverlay({
					buttons: {
						confirm: {
							text: "Close",
							onClick: res,
						},
						deny: {
							text: "Cancel",
							onClick: rej,
						},
					},
					prompt: ["Are you sure you want to exit?", "Any unsaved masks will not be saved."],
				})
			}),
		props: {
			calibration,
			onSuccess: () => {
				Toast.success("Masks successfully saved!")
				closeOverlay(overlayId, true)
			},
			onFailure: () => {
				Toast.error("Masks failed to save... Please try again.")
			},
		},
	})
}
